import { readAppEnv } from './runtimeEnv';

const DEFAULT_API_BASE = '/api';

const normalizeApiBase = (value?: string): string => {
  const trimmed = value?.trim();
  if (!trimmed) return DEFAULT_API_BASE;
  if (trimmed === '/') return DEFAULT_API_BASE;
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
};

export const API_BASE = normalizeApiBase(readAppEnv('VITE_API_BASE'));
